// extracted by mini-css-extract-plugin
module.exports = {"CardStyles":"Card_CardStyles__12m3x","dateStyle":"Card_dateStyle__A5KI6","temperatureStyle":"Card_temperatureStyle__1LWs2","descriptionStyle":"Card_descriptionStyle__34If9"};